import { z } from 'zod';
import { commonOptionalTextInputSchema, commonRequiredTextInputSchema } from 'schemas/text.schema';

export enum GroupMemberType {
  Marker = 'marker',
  NonMarker = 'nonMarker'
}

const groupMemberSchema = z.object({
  groupUserId: z.number().optional(),
  organisationUserId: z.number(),
  checked: z.boolean()
});

/**
 * Represents a group member on the form. A record is created on the form for each potential group
 * member (organisation user with the potentional to become a group user), even if they are not a
 * group member yet.
 */
export type GroupMemberFormValue = z.infer<typeof groupMemberSchema>;

export enum SubmitAction {
  Create = `create`,
  Update = `update`
}

const unrefinedMarkingGroupFormSchema = z.object({
  name: commonRequiredTextInputSchema,
  description: commonOptionalTextInputSchema,
  year: z.string(),
  markerGroupMembers: z.array(groupMemberSchema),
  nonMarkerGroupMembers: z.array(groupMemberSchema),
  submitAction: z.custom<SubmitAction>()
});
export type MarkingGroupFormValues = z.infer<typeof unrefinedMarkingGroupFormSchema>;

export const markingGroupFormSchema = unrefinedMarkingGroupFormSchema;
